var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRulerMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    stroke: "#808080",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ruler-measure"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.25 11.0002V12.8336M5.5 11.0002V13.7502M11 11.0002V13.7502M16.5 11.0002V13.7502M13.75 11.0002V12.8336M2.75 2.75024V6.41691M2.75 4.58358H19.25M19.25 2.75024V6.41691M18.2188 11.0002C18.788 11.0002 19.25 11.4696 19.25 12.048V17.2858C19.25 17.8642 18.788 18.3336 18.2188 18.3336H3.66667C3.42355 18.3336 3.19039 18.237 3.01849 18.0651C2.84658 17.8932 2.75 17.66 2.75 17.4169V12.048C2.75 11.4696 3.212 11.0002 3.78125 11.0002H18.2188Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulerMeasure);
export default __webpack_public_path__ + "static/media/ruler-measure.5f8bcb2b53b3815f9bebcbd2c22649b7.svg";
export { ForwardRef as ReactComponent };